import { styled } from 'styled-components';
import { StyledAlertDialogContent } from '@/shared/ui/alert-dialog/styles';
import { Image } from '@/shared/ui/image/Image';
import { Box } from '@/shared/ui/box/Box';

const StyledPlayResponsiblyDialogContent = styled(StyledAlertDialogContent)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 420px;
  padding: 12px;
  box-sizing: border-box;
  border: 2px solid #fca81d;
  max-height: 90dvh;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border: none;
    border-radius: 0;
    padding-bottom: calc(12px + var(--app-safe-area-bottom));
  }
`;

const Navigation = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  flex-shrink: 0;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

const Title = styled.div`
  width: 100%;
`;

const Description = styled.div`
  width: 100%;
`;

const LogoPartnerWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 24px;
  width: 360px;
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 180px;
  }
`;

/* /images/icons/logo-pagcor.svg — исходный ассет 182×51.68 */
const PagcorLogoImage = styled(Image)`
  flex: 1 0 0;
  min-width: 0;

  & img {
    width: 100%;
    height: auto;
    aspect-ratio: 182 / 51.68;
  }

  @media (max-width: 768px) {
    flex: none;
    width: 180px;

    & img {
      width: 180px;
      height: 51px;
      aspect-ratio: auto;
    }
  }
`;

/* /images/icons/logo-21.svg — исходный ассет 182×59 */
const Badge21LogoImage = styled(Image)`
  flex: 1 0 0;
  min-width: 0;

  & img {
    width: 100%;
    height: auto;
    aspect-ratio: 182 / 59;
  }

  @media (max-width: 768px) {
    flex: none;
    width: 180px;

    & img {
      width: 180px;
      height: 58px;
      aspect-ratio: auto;
    }
  }
`;

export {
  StyledPlayResponsiblyDialogContent,
  Navigation,
  InfoContainer,
  Title,
  Description,
  LogoPartnerWrapper,
  PagcorLogoImage,
  Badge21LogoImage,
};
